/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User My Reviews functionality

define('modules/User/MyReviews',[
    'jquery',
    'global/all',
    'plugins/jquery.rateit.min'
], function ($, Roc) {
    'use strict';

    var totalReviews;
    var baseUrl;

    function refreshControls(pagination) {
        $('select#itemsSort option[data-sortby="' + pagination.sortBy + '"][data-sorttype="' + pagination.sortType + '"]').attr('selected', 'selected');
        $('div.rateit').rateit();
    }

    function refreshReviewsList(pagination) {
        $.get(baseUrl, { 'pageSize': pagination.pageSize, 'page': pagination.page, 'sortBy': pagination.sortBy, 'sortType': pagination.sortType }, function (data) {
            $('#items').html($('#items', data).html());
            refreshControls(pagination);
        });
    }

    function init(initData) {
        totalReviews = initData.totalReviews;
        baseUrl = initData.baseUrl;
        
        var pagination = Roc.Pagination.init(initData, refreshReviewsList);
        refreshControls(pagination);
    };

    // public Methods
    var MyReviews = {
        init: init
    };

    Roc.Logger.debug('MyReviews.js Loaded:', MyReviews);

    // return public methods
    return MyReviews;
});
